import React, { Component } from 'react'

export class GoogleAdsenseLeft extends Component {

    // componentDidMount() {
    //     let adsbygoogle = ((window as any).adsbygoogle || []).push({});
    //     console.log(adsbygoogle, 'adsbygoogle Left');
    // }

    componentDidMount() {
        //@ts-ignore
        (window.adsbygoogle = window.adsbygoogle || []).push({})
    }

    render() {
        return (
            <div style={{ width: '250px' }}>
                <ins className="adsbygoogle"
                    style={{ display: "block", textAlign: "center" }}
                    data-ad-layout="in-article"
                    data-ad-format="fluid"
                    data-ad-client="ca-pub-7075216358322637"
                    data-ad-slot="5178241657">
                </ins>
            </div>
        )
    }
}